import { useTranslation } from '@hbs-us/ui';

import type { UserListItemDto } from '../contractsMirror.js';

/**
 * Active/inactive status badge for a user row. The status is carried by TEXT (never by
 * color alone — A11Y-01); the token-styled pill is supplementary. Every color is a locked
 * `@hbs-us/ui` token (BRAND-06).
 */

const BASE = 'inline-flex items-center rounded-full px-2.5 py-0.5 font-medium text-xs';
const ACTIVE = 'bg-secondary text-secondary-foreground';
const INACTIVE = 'border border-border bg-background text-muted-foreground';

export function UserStatusBadge({ user }: { user: UserListItemDto }) {
  const { t } = useTranslation();
  const isActive = user.active === 1;
  return (
    <span className={`${BASE} ${isActive ? ACTIVE : INACTIVE}`}>
      {isActive ? t('users:status.active') : t('users:status.inactive')}
    </span>
  );
}
